// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/CompanyProfile.yaml
// Generated: 2026-07-11T16:13:06.410Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateCompanyProfile, UpdateCompanyProfile, CompanyProfile } from '@/types/core/CompanyProfile';

/**
 * CompanyProfile Service
 * CRUD operations for CompanyProfile via the ABP API.
 */
export const companyProfileService = new EntityService<CompanyProfile, CreateCompanyProfile, UpdateCompanyProfile>(
  '/api/core/companyprofile',
  'CompanyProfile',
);
